import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Chip } from "@mui/material";

const PaymentTable = ({ paymentReport, setPagination }) => {
  const formattedPaymentReport = paymentReport?.map((payment) => ({
    ...payment,
    created_at: new Date(payment.created_at).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),
  }));

  const columns = [
    { field: "id", headerName: "Id", width: 100 },
    { field: "business_name", headerName: "Franchisee Name", width: 170 },
    { field: "service_name", headerName: "service Name", width: 180 },
    { field: "user_name", headerName: "user Name", width: 170 },
    { field: "user_phone", headerName: "user Phone", width: 170 },
    { field: "amount", headerName: "Amount", width: 170 },
    { field: "payment_method", headerName: "payment Method", width: 170 },
    { field: "created_at", headerName: "Payment Date", width: 170 },
    {
      field: "is_refund",
      headerName: "Status",
      width: 170,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Refunded" : "Captured"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
            minWidth: "100px",
          }}
        />
      ),
    },
  ];
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 1000, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <DataGrid
          rows={formattedPaymentReport}
          columns={columns}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          disableSelectionOnClick
          onPaginationModelChange={setPagination}
        />
      </Box>
    </>
  );
};

export default PaymentTable;
